import { render, staticRenderFns } from "./UninstallLayout.vue?vue&type=template&id=4a21a3c5&scoped=true&"
import script from "./UninstallLayout.vue?vue&type=script&lang=js&"
export * from "./UninstallLayout.vue?vue&type=script&lang=js&"
import style0 from "./UninstallLayout.vue?vue&type=style&index=0&id=4a21a3c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a21a3c5",
  null
  
)

export default component.exports